(function () {
  const fieldSelector = '[data-bundle-instructions]';
  const storageKey = 'noirsetBundleInstructions';
  let syncTimeout;

  function getField() {
    return document.querySelector(fieldSelector);
  }

  function getValue() {
    const field = getField();
    return field ? field.value.trim() : '';
  }

  function restoreValue() {
    const field = getField();
    if (!field || field.value) return;

    const storedValue = window.localStorage.getItem(storageKey);
    if (storedValue) field.value = storedValue;
  }

  function syncCartAttribute(value) {
    if (!value) return;

    window.localStorage.setItem(storageKey, value);

    fetch('/cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Instructions bundle': value
        }
      })
    }).catch(function () {});
  }

  function scheduleSync() {
    window.clearTimeout(syncTimeout);
    syncTimeout = window.setTimeout(function () {
      syncCartAttribute(getValue());
    }, 350);
  }

  function start() {
    const field = getField();
    if (!field) return;

    restoreValue();

    field.addEventListener('input', scheduleSync);
    field.addEventListener('change', function () {
      syncCartAttribute(getValue());
    });

    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        if (!target || !target.closest) return;

        if (target.closest('.noirset-bundle-widget, .product-form__submit, [name="add"]')) {
          syncCartAttribute(getValue());
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (event.target && event.target.matches('form[action*="/cart/add"]')) {
          syncCartAttribute(getValue());
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
